import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'hb-explorercompatibility',
  templateUrl: './explorerCompatibility.component.html',
  styleUrls: ['./explorerCompatibility.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExplorerCompatibilityComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
